import axios from "axios";
import { getPresignedUrlRestApi } from "./getPresignedUrlRestApi";
export const getAllListAssetDetails = {
  mixins: [getPresignedUrlRestApi],
  data() {
    return {
      getAllListAssetDetailsArray: [],
      assetImagesKeysArray: [],
      assetCerticatesArray: [],
      overlay: false,
      noDataText: null,
      imageUrls: [],
    };
  },
  methods: {
    async getAllListAssetDetailsMethod(qr_code_display_id, asset_qr_code_url) {
      this.overlay = true;

      try {
        this.getAllListAssetDetailsArray = [];
        this.assetImagesKeysArray = [];
        this.assetCerticatesArray = [];
        const apiUrl = process.env.VUE_APP_AWS_ASSET_DETAILS_REST_API_END_POINT;
        console.log("apiUrl", apiUrl);
        const inputParams = {
          qr_code_display_id: qr_code_display_id,
          asset_qr_code_url: asset_qr_code_url,
        };
        console.log("inputParams", inputParams);
        const result = await axios.post(apiUrl, inputParams, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log("result of getAllListAssetDetailsMethod", result);
        if (result.data.status === "SUCCESS") {

          this.getAllListAssetDetailsArray = result.data.data;

          const certificates = this.getAllListAssetDetailsArray[0].asset_certificates || [];
          this.assetCerticatesArray = [...certificates];
          const images = this.getAllListAssetDetailsArray[0].asset_images || [];
          this.assetImagesKeysArray = [...images];
          
          await this.fetchImageUrls();

        }
      } catch (error) {
        console.log("Error in getAllListAssetDetailsMethod:", error);

        this.getAllListAssetDetailsArray = [];
        this.assetImagesKeysArray = [];
        this.assetCerticatesArray = [];
        this.noDataText = error;
        return "ERROR";
      } finally {
        this.overlay = false;
      }
    },
    async fetchImageUrls() {
      const keys = [...this.assetImagesKeysArray];
      if (keys && keys.length > 0) {
        this.imageUrls = await Promise.all(
          keys.map(async (key) => {
            try {
              const url = await this.getPresignedUrlRestApiMethod(key);
              return url;
            } catch (error) {
              console.log("ok..", error);
              return "@/assets/placeHolderImage.jpg"; // Fallback image
            }
          })
        );
      }
    },
  },
};
